import { useState, useEffect } from 'react';
import {
  Button,
  Cascader,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Spin,
  Upload,
  message,
  Tooltip,
  Radio,
} from 'antd';
import { UploadOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import qs from 'query-string';
import moment from 'moment/moment';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import AuthorizationInfo from '@/components/FormInfo/AuthorizationInfo';
import { getArea, getDictType } from '@/services/common';
import {
  uploadFileUrl,
  addApply,
  getApplicationInfo,
  updateBackApply,
  getMajorProjectTypeSel,
  getMajorProjectSubTypeSel,
  getEconomicSel,
} from '@/services/majorFinancing';
import './index.less';
import {
  PROJECT_TYPE, RATING_CREDIT, ENTERPRISE_TYPE, PROJECT_RESERVE_PROJECT, ZD_PROJECT_NATURE, ZD_FINANCIAL_SUPPORT, ZD_PRO_COMPLETED, ZD_SUBJECT_TYPE,
  ZD_ENTERPRISE_TYPE,
} from '@/utils/mappingDict';
import { addDecimalNum } from '@/utils/utils';

const formItemLayout = {
  labelCol: {
    sm: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

const formItemLayout1 = {
  labelCol: {
    sm: { span: 12 },
  },
  wrapperCol: {
    sm: { span: 12 },
  },
};

const defaultParams = [PROJECT_TYPE, RATING_CREDIT, ENTERPRISE_TYPE, PROJECT_RESERVE_PROJECT, ZD_PROJECT_NATURE, ZD_FINANCIAL_SUPPORT, ZD_PRO_COMPLETED, ZD_SUBJECT_TYPE,
  ZD_ENTERPRISE_TYPE].join(',');

export default function Application() {
  const [form] = Form.useForm();
  const reserveProject = Form.useWatch('reserveProject', form);
  const financialFunds = Form.useWatch('financialFunds', form); // 财政资金
  const projectNature = Form.useWatch('projectNature', form); // 项目性质
  const Navigate = useNavigate();
  const { search } = useLocation();
  const { backId } = qs.parse(search);
  const { userType } = useSelector((state) => state);
  const [authInfoModal, setAuthInfoModal] = useState(false); // 授权书内容
  const [list, setList] = useState([]); // 附件内容
  // const [num, setNum] = useState(0); // 财政资金

  const { data: area = [] } = useRequest(getArea); // 区域
  const { data: dict = {} } = useRequest(getDictType, { // 筛选项字典
    defaultParams: [defaultParams],
  });

  // 项目类型(主)
  const { data: projectTypeSel = [] } = useRequest(getMajorProjectTypeSel);
  // 项目类型(辅)
  const { data: projectSubTypeSel = [] } = useRequest(getMajorProjectSubTypeSel);
  // 国民经济代码
  const { data: economicSel = [] } = useRequest(getEconomicSel);

  const { loading: applyLoading, run: backRun } = useRequest(getApplicationInfo, {
    manual: true,
    onSuccess(res) {
      if (res) {
        const fileList = [];
        if (!isEmpty(res?.projectFiles)) {
          // eslint-disable-next-line array-callback-return
          res.projectFiles.map((item, index) => {
            fileList.push({
              uid: index.toString(),
              name: item.fileName,
              status: 'done',
              url: item.fileUrl,
            });
          });
        }
        setList(fileList);
        // setNum(Number(res?.financialFunds));
        const obj = {
          ...res,
          projectFiles: fileList,
          areaId: [res.provinceId, res.cityId, res.areaId],
          startTime: res.startTime && moment(res.startTime, 'YYYY-MM-DD'),
          endTime: res.endTime && moment(res.endTime, 'YYYY-MM-DD'),
          estimated: res.estimated && moment(res.estimated, 'YYYY-MM-DD'),
          capitalCreate: res.capitalCreate && moment(res.capitalCreate, 'YYYY-MM-DD'),
        };
        form.setFieldsValue(obj);
      }
    },
  });

  const { loading, run } = useRequest(addApply, {
    manual: true,
    onSuccess() {
      Navigate('/result');
    },
  });

  const { loading: updateLoading, run: updateRun } = useRequest(updateBackApply, {
    manual: true,
    onSuccess() {
      Navigate('/result');
    },
  });

  const props = {
    name: 'file',
    accept: '.rar,.zip,.doc,.docx,.pdf',
    action: uploadFileUrl,
    headers: {
      authorization: 'authorization-text',
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        message.error('请上传10M以下文件!');
      }
      return isLt2M;
    },
    onChange({ file, fileList }) {
      if (isEmpty(fileList)) {
        form.setFieldsValue({ projectFiles: undefined });
      }
      setList(fileList);
      if (file.status === 'done') {
        message.success('上传成功');
      } else if (file.status === 'error') {
        message.error('上传失败');
      }
    },
  };

  useEffect(() => {
    if (userType !== 3) {
      Navigate('/home');
    }
    if (backId) {
      backRun(backId);
    }
  }, []);

  function onFinish(values) {
    if (values?.financialFunds > 0 && !isEmpty(values?.projectFiles)) {
      const file = values.projectFiles.fileList || values.projectFiles;
      // eslint-disable-next-line no-param-reassign
      values.projectFiles = file.map((item) => ({
        fileName: item.name,
        fileUrl: item?.response?.data || item?.url,
      }));
    } else {
      // eslint-disable-next-line no-param-reassign
      values.projectFiles = undefined;
    }
    const obj = {
      ...values,
      provinceId: values.areaId[0],
      cityId: values.areaId[1],
      areaId: values.areaId[2],
      startTime: values.startTime && moment(values.startTime).format('YYYY-MM-DD'),
      endTime: values.endTime && moment(values.endTime).format('YYYY-MM-DD'),
      estimated: values.estimated && moment(values.estimated).format('YYYY-MM-DD'),
      capitalCreate: values.capitalCreate && moment(values.capitalCreate).format('YYYY-MM-DD'),
      id: backId,
    };
    if (backId) {
      // 退回记录从新申请
      updateRun(obj);
    } else {
      // 新申请
      run(obj);
    }
  }

  function checkAuthorize(_, value) {
    const promise = Promise;
    if (!value) {
      return promise.reject('请勾选同意协议');
    }
    return promise.resolve();
  }

  const calcSum = () => {
    const values = form.getFieldsValue([
      'financingAmount',
      'financialFunds',
      'selfOwnedFunds',
      'otherAmount',
    ]);

    const sum = addDecimalNum([values.financingAmount, values.financialFunds, values.selfOwnedFunds, values.otherAmount]);

    form.setFieldsValue({
      projectSum: sum,
    });
  };

  return (
    <div className="major-financing-application">
      <div className="content-width">
        <div className="major-financing-application__title">重大融资申请</div>
        <div className="margin-top20">
          <Spin spinning={applyLoading}>
            <Form
              {...formItemLayout}
              form={form}
              name="form"
              className="form"
              onFinish={onFinish}
            >
              <div className="form-info__box">
                <div className="form-info__box-title">融资需求信息</div>
                <div className="form-info__box-con">
                  <Row>
                    <Col span={12}>
                      <Form.Item
                        name="projectName"
                        label="项目名称"
                        rules={[
                          {
                            required: true,
                            message: '请输入项目名称',
                          },
                          { whitespace: true },
                        ]}
                      >
                        <Input placeholder="请输入项目名称" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="projectCode"
                        label="项目审批代码"
                      >
                        <Input placeholder="请输入项目审批代码" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="itemTypes"
                        label="项目类型（主）"
                        rules={[
                          {
                            required: true,
                            message: '请选择项目类型（主）',
                          },
                        ]}
                      >
                        <Cascader options={projectTypeSel} placeholder="请选择项目类型（主）" fieldNames={{ label: 'name', value: 'id', children: 'children' }} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="itemTypes1"
                        label="项目类型（辅）"
                        dependencies={['itemTypes']}
                        rules={[
                          {
                            required: true,
                            message: '请选择项目类型（辅）',
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const main = getFieldValue('itemTypes');
                              const mainValue = main?.[0]; // Cascader 选中一级值

                              // 1️⃣ 限制最多 2 个
                              if (value && value.length > 2) {
                                // eslint-disable-next-line prefer-promise-reject-errors
                                return Promise.reject('项目类型（辅）最多选择 2 个');
                              }

                              // 2️⃣ 不允许与主类型相同
                              if (mainValue && value?.includes(mainValue)) {
                                // eslint-disable-next-line prefer-promise-reject-errors
                                return Promise.reject('项目类型（辅）不能与主类型相同');
                              }

                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Select
                          mode="multiple"
                          placeholder="请选择项目类型（辅）"
                          fieldNames={{ label: 'name', value: 'code' }}
                          options={projectSubTypeSel}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="projectNature"
                        label="项目性质"
                        rules={[
                          {
                            required: true,
                            message: '请选择项目性质',
                          },
                        ]}
                      >
                        <Select
                          placeholder="请选择项目性质"
                          fieldNames={{ label: 'name', value: 'val' }}
                          options={dict[ZD_PROJECT_NATURE]}
                        />
                      </Form.Item>
                    </Col>
                    {
                      projectNature === '5'
                      && (
                      <Col span={12}>
                        <Form.Item
                          name="financialSupports"
                          label="财政资金支持类型"
                          rules={[
                            {
                              required: true,
                              message: '请选择财政资金支持类型',
                            },
                          ]}
                        >
                          <Select
                            mode="multiple"
                            placeholder="请选择财政资金支持类型"
                            fieldNames={{ label: 'name', value: 'val' }}
                            options={dict[ZD_FINANCIAL_SUPPORT]}
                          />
                        </Form.Item>
                      </Col>
                      )
                    }
                    <Col span={12}>
                      <Form.Item
                        name="projectType"
                        label="建设性质"
                        rules={[
                          {
                            required: true,
                            message: '请选择建设性质',
                          },
                        ]}
                      >
                        <Select placeholder="请选择建设性质">
                          {
                            dict?.projectType?.map((item) => (
                              <Select.Option value={item.val} key={item.val}>
                                {item.name}
                              </Select.Option>
                            ))
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="projectSum"
                        label={(
                              <span>
                              投资总额
                                <Tooltip title="投资总额 = 贷款总需求 + 财政投入 + 企业自筹资本金 + 其他投入">
                                  <QuestionCircleOutlined />
                                </Tooltip>
                              </span>
                              )}
                        rules={[
                          {
                            required: true,
                            message: '请输入投资总额',
                          },
                        ]}
                      >
                        <InputNumber
                          disabled
                          placeholder="请输入投资总额"
                          addonAfter="万元"
                          min={0}
                          max={99999999}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="financialFunds"
                        label="财政投入"
                        rules={[
                          {
                            required: true,
                            message: '请输入财政投入（如无，请填写0）',
                          },
                        ]}
                      >
                        <InputNumber
                          placeholder="请输财政投入"
                          addonAfter="万元"
                          min={0}
                          max={99999999}
                          onChange={calcSum}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    {
                      financialFunds > 0 && (
                        <Col span={12}>
                          <Form.Item
                            name="projectFiles"
                            label="财政投入佐证材料"
                            rules={[
                              {
                                required: true,
                                message: '请上传财政投入佐证材料',
                              },
                            ]}
                          >
                            <Upload {...props} fileList={list}>
                              <Button icon={<UploadOutlined />}>文件上传</Button>
                            </Upload>
                          </Form.Item>
                        </Col>
                      )
                    }
                    <Col span={12}>
                      <Form.Item
                        name="selfOwnedFunds"
                        label="企业自筹资本金"
                        rules={[
                          {
                            required: true,
                            message: '请输入企业自筹资本金',
                          },
                        ]}
                      >
                        <InputNumber
                          placeholder="请输入企业自筹资本金"
                          addonAfter="万元"
                          min={0}
                          max={99999999}
                          style={{ width: '100%' }}
                          onChange={calcSum}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="financingAmount"
                        label="贷款总需求"
                        rules={[
                          { required: true, message: '请输入贷款总需求' },
                        ]}
                      >
                        <InputNumber
                          placeholder="请输入贷款总需求"
                          addonAfter="万元"
                          min={0}
                          max={99999999}
                          style={{ width: '100%' }}
                          onChange={calcSum}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="otherAmount"
                        label="其他投入"
                      >
                        <InputNumber
                          placeholder="请输入其他投入"
                          addonAfter="万元"
                          min={0}
                          max={99999999}
                          style={{ width: '100%' }}
                          onChange={calcSum}
                        />
                      </Form.Item>
                    </Col>
                    {
                      projectNature === '8' && (
                        <>
                          <Col span={12}>
                            <Form.Item
                              name="purchasingInsurance"
                              label="是否考虑购买保险产品"
                              rules={[
                                { required: true, message: '请选择是否考虑购买保险产品' },
                              ]}
                            >
                              <Radio.Group>
                                <Radio value={1}>是</Radio>
                                <Radio value={2}>否</Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              {...formItemLayout1}
                              name="mortgage"
                              label="是否考虑办理设施农业产权抵押"
                            >
                              <Radio.Group>
                                <Radio value={1}>是</Radio>
                                <Radio value={2}>否</Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Col>
                        </>
                      )
                    }
                    <Col span={12}>
                      <Form.Item
                        name="capitalTerm"
                        label="资金使用期限"
                        rules={[
                          { required: true, message: '请输入资金使用期限' },
                        ]}
                      >
                        <InputNumber
                          placeholder="请输入资金使用期限"
                          addonAfter="月"
                          min={1}
                          max={999}
                          precision={0}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="estimated"
                        label="资金预计使用时间"
                        rules={[
                          { required: true, message: '请选择资金预计使用时间' },
                        ]}
                      >
                        <DatePicker
                          placeholder="请选择资金预计使用时间"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="purpose"
                        label="资金用途"
                        rules={[
                          { required: true, message: '请输入资金用途' },
                          { whitespace: true },
                        ]}
                      >
                        <Input.TextArea maxLength={500} showCount placeholder="请输入资金用途" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="areaId"
                        label="建设地点"
                        rules={[
                          {
                            required: true,
                            message: '请选择建设地点',
                          },
                        ]}
                      >
                        <Cascader options={area} placeholder="请选择项目所在区域" fieldNames={{ label: 'name', value: 'id', children: 'children' }} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="address"
                        label="详细建设地点"
                        rules={[
                          { required: true, message: '请输入详细建设地点' },
                          { whitespace: true },
                        ]}
                      >
                        <Input placeholder="请输入详细建设地点" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="startTime"
                        label="拟开工日期"
                        rules={[
                          {
                            required: true,
                            message: '请选择拟开工日期',
                          },
                        ]}
                      >
                        <DatePicker
                          placeholder="请输入拟开工日期"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="endTime"
                        label="拟建成日期"
                        rules={[
                          {
                            required: true,
                            message: '请选择拟建成日期',
                          },
                        ]}
                      >
                        <DatePicker
                          placeholder="请输入拟建成日期"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="contactPerson"
                        label="项目联系人"
                        rules={[
                          { required: true, message: '请输入项目联系人' },
                          { whitespace: true },
                        ]}
                      >
                        <Input placeholder="请输入项目联系人" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="contactTel"
                        label="手机号"
                        rules={[
                          { required: true, message: '请输入手机号' },
                          { whitespace: true },
                        ]}
                      >
                        <Input placeholder="请输入手机号" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="departmentPosition"
                        label="联系人部门职务"
                        rules={[
                          { required: true, message: '请输入联系人部门职务' },
                          { whitespace: true },
                        ]}
                      >
                        <Input placeholder="请输入联系人部门职务" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        {...formItemLayout1}
                        name="contribute"
                        label="是否具备资本金出资能力"
                      >
                        <Radio.Group>
                          <Radio value={1}>是</Radio>
                          <Radio value={2}>否</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    {
                      projectNature === '8' && (
                        <Col span={12}>
                          <Form.Item
                            name="economics"
                            label="国民经济代码"
                            rules={[
                              {
                                required: true,
                                message: '请选择国民经济代码',
                              },
                            ]}
                          >
                            <Cascader options={economicSel} placeholder="请选择国民经济代码" fieldNames={{ label: 'name', value: 'id', children: 'children' }} />
                          </Form.Item>
                        </Col>
                      )
                    }
                    <Col span={12}>
                      <Form.Item
                        name="nationProject"
                        label="是否为国家级重大项目"
                        rules={[
                          { required: true, message: '请选择是否为国家级重大项目' },
                        ]}
                      >
                        <Radio.Group>
                          <Radio value={0}>是</Radio>
                          <Radio value={1}>否</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="provincialProject"
                        label="是否为省级重大项目"
                        rules={[
                          { required: true, message: '请选择是否为省级重大项目' },
                        ]}
                      >
                        <Radio.Group>
                          <Radio value={0}>是</Radio>
                          <Radio value={1}>否</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        {...formItemLayout1}
                        name="reserveProject"
                        label="是否属于“1+1+8”千亿级产业链融资储备项目"
                        rules={[
                          { required: true, message: '请选择是否属于“1+1+8”千亿级产业链融资储备项目' },
                        ]}
                      >
                        <Radio.Group>
                          <Radio value={1}>是</Radio>
                          <Radio value={0}>否</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    {
                      reserveProject === 1 && (
                        <Col span={12}>
                          <Form.Item
                            name="reserveProjectCode"
                            label="所属产业链"
                            rules={[
                              { required: true, message: '请选择所属产业链' },
                            ]}
                          >
                            <Select placeholder="请选择所属产业链" options={dict?.projectReserveProject} fieldNames={{ label: 'name', value: 'val' }} />
                          </Form.Item>
                        </Col>
                      )
                    }
                    <Col span={12}>
                      <Form.Item
                        name="duration"
                        label="项目期限"
                        rules={[
                          {
                            required: true,
                            message: '请输入项目期限',
                          },
                        ]}
                      >
                        <InputNumber
                          placeholder="请输入项目期限"
                          addonAfter="年"
                          min={0}
                          max={9999}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="incomeSource"
                        label="收入来源"
                        rules={[
                          { required: true, message: '请输入收入来源' },
                          { whitespace: true },
                        ]}
                      >
                        <Input placeholder="请输入收入来源" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="rateReturn"
                        label="项目回报率"
                        rules={[
                          {
                            required: true,
                            message: '请输入项目回报率',
                          },
                        ]}
                      >
                        <InputNumber
                          placeholder="请输入项目回报率"
                          addonAfter="%"
                          min={0}
                          max={9999}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="paybackPeriod"
                        label="项目回收期"
                        rules={[
                          {
                            required: true,
                            message: '请输入项目回收期',
                          },
                        ]}
                      >
                        <InputNumber
                          placeholder="请输入项目回收期"
                          addonAfter="年"
                          min={0}
                          max={9999}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="projectProgress"
                        label="项目进展"
                        rules={[
                          { required: true, message: '请输入项目进展' },
                          { whitespace: true },
                        ]}
                      >
                        <Input placeholder="请输入项目进展" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="proceduresCompleted"
                        label="已完成前期审批手续"
                        rules={[
                          {
                            required: true,
                            message: '请选择已完成前期审批手续',
                          },
                        ]}
                      >
                        <Select
                          placeholder="请选择已完成前期审批手续"
                          fieldNames={{ label: 'name', value: 'val' }}
                          options={dict[ZD_PRO_COMPLETED]}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="projectScale"
                        label="主要建设内容及规模"
                        rules={[
                          { required: true, message: '请输入主要建设内容及规模' },
                          { whitespace: true },
                        ]}
                      >
                        <Input.TextArea maxLength={500} showCount placeholder="请输入主要建设内容及规模" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="otherElements"
                        label="可补充其他要素"
                      >
                        <Input.TextArea maxLength={500} showCount placeholder="请输入可补充其他要素" />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="form-info__box">
                <div className="form-info__box-title">企业信息</div>
                <div className="form-info__box-con">
                  <Row>
                    <Col span={12}>
                      <Form.Item
                        name="subjectType"
                        label="主体类型"
                        rules={[
                          {
                            required: true,
                            message: '请选择主体类型',
                          },
                        ]}
                      >
                        <Select
                          placeholder="请选择主体类型"
                          fieldNames={{ label: 'name', value: 'val' }}
                          options={dict[ZD_SUBJECT_TYPE]}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="enterpriseType"
                        label="企业类型"
                        rules={[
                          {
                            required: true,
                            message: '请选择企业类型',
                          },
                        ]}
                      >
                        <Select placeholder="请选择企业类型">
                          {
                            dict?.enterpriseType?.map((item) => (
                              <Select.Option value={item.val} key={item.val}>
                                {item.name}
                              </Select.Option>
                            ))
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="capitalCreate"
                        label="企业成立时间"
                        rules={[
                          { required: true, message: '请选择企业成立时间' },
                        ]}
                      >
                        <DatePicker
                          placeholder="请选择企业成立时间"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="capitalRegistered"
                        label="注册资金"
                        rules={[
                          {
                            required: true,
                            message: '请输入注册资金',
                          },
                        ]}
                      >
                        <InputNumber
                          placeholder="请输入注册资金"
                          addonAfter="万元"
                          min={0}
                          max={99999999}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="liabilityRatio"
                        label="资产负债率"
                        rules={[
                          {
                            required: true,
                            message: '请输入资产负债率',
                          },
                        ]}
                      >
                        <InputNumber
                          placeholder="请输入资产负债率"
                          addonAfter="%"
                          min={0}
                          max={9999}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="ratingCredit"
                        label="信用等级"
                        rules={[
                          {
                            required: true,
                            message: '请选择信用等级',
                          },
                        ]}
                      >
                        <Select placeholder="请选择信用等级">
                          {
                            dict?.ratingCredit?.map((item) => (
                              <Select.Option value={item.val} key={item.val}>
                                {item.name}
                              </Select.Option>
                            ))
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="principal"
                        label="负责人"
                        rules={[
                          { required: true, message: '请输入负责人' },
                          { whitespace: true },
                        ]}
                      >
                        <Input placeholder="请输入负责人" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="principalTel"
                        label="联系方式"
                        rules={[
                          { required: true, message: '请输入联系方式' },
                          { whitespace: true },
                        ]}
                      >
                        <Input placeholder="请输入联系方式" />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="authorize">
                <Form.Item
                  name="authorize"
                  wrapperCol={{ span: 24 }}
                  valuePropName="checked"
                  rules={[
                    { validator: checkAuthorize },
                  ]}

                >
                  <Checkbox>
                    同意并接受
                    <Button type="link" className="authorize-name" onClick={() => setAuthInfoModal(true)}>《直通车平台业务授权协议》</Button>
                  </Checkbox>
                </Form.Item>
              </div>
              <div className="submit-btn-box">
                <Button type="primary" htmlType="submit" loading={loading || updateLoading}>
                  提交申请
                </Button>
              </div>
            </Form>
          </Spin>
          <Modal title="授权协议查看" open={authInfoModal} width={900} footer={null} onCancel={() => setAuthInfoModal(false)}>
            <div dangerouslySetInnerHTML={{ __html: AuthorizationInfo }} style={{ maxHeight: 600, overflowY: 'scroll' }} />
          </Modal>
        </div>
      </div>

    </div>
  );
}
